import { render, staticRenderFns } from "./UserHelpList.vue?vue&type=template&id=0de8dd2a&"
import script from "./UserHelpList.vue?vue&type=script&lang=js&"
export * from "./UserHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports